<template>
    <div class="card" v-if="user">
        <div class="card-header" v-if="user.name||user.family">
            <img v-if="user.image" :src="user.image" alt="user image">
            <svg v-else xmlns="http://www.w3.org/2000/svg" fill="#000000" enable-background="new 0 0 24 24" viewBox="0 0 24 24"><g ><rect  fill="none" height="24" width="24"></rect></g><g ><path  d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 4c1.93 0 3.5 1.57 3.5 3.5S13.93 13 12 13s-3.5-1.57-3.5-3.5S10.07 6 12 6zm0 14c-2.03 0-4.43-.82-6.14-2.88C7.55 15.8 9.68 15 12 15s4.45.8 6.14 2.12C16.43 19.18 14.03 20 12 20z"></path></g></svg>
            <b>{{ user.name??'' }} {{ user.family??'' }}</b>
        </div>
        <div class="card-body" v-if="user.qr_code_url">
            <img :src="user.qr_code_url" alt="user qrcode">
        </div>
        <div class="card-footer">
            <p>
                جهت ارتباط کافیست عکس کد شده را جستجو کنید
            </p>
        </div>
    </div>
</template>
<script setup>
    import { useUserStore } from '@/stores/user';
    const user = useUserStore()
</script>
<style scoped>
    .card-header {
        height: 60px;
        display: flex;
        flex-wrap: nowrap;
        flex-direction: row-reverse;
        align-items: center;
        justify-content: flex-start;
        gap: 15px;
    }
    .card-header img,.card-header svg{
        height: 100%;
        border: 1px dashed green;
        border-radius: 50px;
    }
    .card-body{
        text-align: center;
    }
    .card-body img{
        width: 85%;
        padding: 20px;
        box-sizing: border-box;
        background: #2d4949;
        border-radius: 10px;
        margin: 7px;
    }
    .card-footer p{
        padding: 20px 0;
        color: blue;
        font-size: 15px;
        font-weight: bolder;
        text-align: center;
        border-radius: 10px;
        background: #e9e5e5;
        margin: 10px 0;
    }
</style>